import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core'
import { CurrencyPipe as NgCurrencyPipe } from '@angular/common'

import { SessionService } from '../services/session/session.service'
import { invalidPipeArgumentError } from './invalid-pipe-argument-error'
import { get, merge } from 'lodash';

@Pipe({
  name: 'currency',
  standalone: false
})
export class CurrencyPipe implements PipeTransform {
  private pipe

  private currencyCode: string
  private symbolDisplay: string

  constructor(@Inject(LOCALE_ID) locale: string, session: SessionService) {
    this.pipe = new NgCurrencyPipe(locale)

    const options = get(session, 'account.options') || {}
    this.currencyCode = options['default_currency'] || 'USD'
    this.symbolDisplay = options['currency_symbol'] || 'symbol';
  }

  transform(
    value: number,
    options: any = {}
  ): string {
    let decimalPlaces: number

    if (isNaN(value)) {
      throw invalidPipeArgumentError('currency', value)
    }

    if (value == null) {
      return 'n/a'
    }

    if (!isNaN(options['decimal_places'])) {
      decimalPlaces = options['decimal_places']
    } else {
      decimalPlaces = 2
    }

    const opts = merge({
      currency: this.currencyCode,
      symbolDisplay: this.symbolDisplay,
      digits: `1.${decimalPlaces}-${decimalPlaces}`
    }, options)

    return this.pipe.transform(value, opts['currency'], opts['symbolDisplay'], opts['digits'])
  }
}
